import { Ref } from 'vue';
import { useFormValidation, email, required, minLength } from 'Helpers/form';
import { FormModelSubscribeNewsletter } from '../models/FormModelSubscribeNewsletter';

export function useFormValidationSubscribeNewsletter(formModel: Ref<FormModelSubscribeNewsletter>) {
  const rules = {
    email: {
      email,
      required,
      minLength: minLength(5),
    },
  };

  return useFormValidation(rules, formModel);
}
